import React, { useState, useEffect } from 'react'
import { Redirect } from 'react-router-dom'
import PropTypes from 'prop-types'
import { useConfig } from '@peracto/peracto-config'

import { Form, Group, Input, Select, Checkbox, File, Modal, FormActions } from '@peracto/peracto-ui'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/pro-regular-svg-icons/faTrash'
import { faExclamationTriangle } from '@fortawesome/pro-regular-svg-icons/faExclamationTriangle'

import { toast } from 'react-toastify'

import { DELETE, useClient } from '@peracto/client'

export const MODE_ADD = 'add'
export const MODE_EDIT = 'edit'

const CountriesForm = ({ mode = MODE_EDIT, values, ...props }) => {
    const [showDialog, setShowDialog] = useState(false)
    const [country, setCountry] = useState()
    const [redirect, setRedirect] = useState()

    const { client } = useClient()
    const config = useConfig()
    const { countries } = config.get('features', {})

    useEffect(() => {
        if (!countries?.manageCountries) {
            setRedirect('/countries')
        }
    }, [])

    const storefrontURL = process.env.REACT_APP_STOREFRONT_URL || window.location.origin
    const storeModeOptions = [
        {
            label: 'Ecommerce',
            value: 'ecommerce',
        },
        {
            label: 'Distributor',
            value: 'distributor',
        },
        {
            label: 'Catalogue',
            value: 'catalogue',
        },
        {
            label: 'Hidden',
            value: 'hidden',
        },
    ]

    return (
        <>
            {redirect && <Redirect to={redirect} />}
            <Form
                autoComplete="off"
                values={{
                    ...values,
                }}
                {...props}
            >
                <Group key="country-settings" id="country-settings" name="Country Settings">
                    <Select
                        name="storeMode"
                        label="Store Mode"
                        placeholder="Please select..."
                        options={storeModeOptions}
                        testId="storeMode"
                        help="The store mode determines how the country will be displayed in the storefront and how it will function. Ecommerce countries will be displayed in the storefront and will allow customers to purchase products. Distributor countries will redirect to the distributor URL provided. Catalogue countries will be displayed in the storefront but will not allow customers to purchase products. Hidden countries will not be displayed in the storefront."
                    />

                    <Checkbox
                        name="ecommerceEnabled"
                        label="Ecommerce Enabled"
                        testId="ecommerceEnabled"
                    />

                    <Input
                        name="distributorUrl"
                        label="Distributor URL"
                        placeholder="Enter Distributor URL..."
                        testId="distributorUrl"
                        help="If a Distributor URL is provided, the country will redirect to this URL instead of the storefront."
                    />

                    <Input
                        name="localisedName"
                        label="Localised Name"
                        placeholder="Enter Localised Name..."
                        testId="localisedName"
                        help="The name of the country in the local language."
                    />

                    <File
                        label="Flag Image"
                        name={`flagUrl`}
                        placeholder="Upload Flag Image..."
                        testId="flagUrl"
                        help="Upload a flag image for the country."
                    />
                </Group>

                <Group key="address-settings" id="address-settings" name="Address Settings">
                    <Checkbox
                        name="validForBilling"
                        label="Valid for Billing"
                        testId="validForBilling"
                    />

                    <Checkbox
                        name="validForDelivery"
                        label="Valid for Delivery"
                        testId="validForDelivery"
                    />
                </Group>
            </Form>
        </>
    )
}

export default CountriesForm
